import R from 'ramda'
import {createSelector} from 'reselect'

const latLngTollatLng = R.memoize(latLng => L.latLng(latLng))
const latlngboundsToLLatLng = R.memoize(bounds => L.latLngBounds(latLngTollatLng(bounds.topLeft), latLngTollatLng(bounds.bottomRight)))
const fitsInViewPort = R.memoize(R.curry((estate, viewPort) => viewPort.contains(latLngTollatLng(estate.coordinates))))

export default createSelector(
    [
      (state) => state.estateMap,
      (state) => latlngboundsToLLatLng(state.viewPort)
    ], 
    (estates, viewPort) => {
      return R.filter(fitsInViewPort, estates)
    }
)




/** WEBPACK FOOTER **
 ** ./app/selectors/visibleEstatesOnMap.js
 **/